import React, { useState } from "react";

function MatchdaySlider({ maxMatchday, onChange }) {
  const [matchday, setMatchday] = useState(maxMatchday);

  const handleChange = (e) => {
    const value = parseInt(e.target.value);
    setMatchday(value);
    onChange(value); // call your function
  };

  return (
    <div>
      <input
        type="range"
        min={1}
        max={maxMatchday}
        value={matchday}
        step={1}
        onChange={handleChange}
      />
      <span> Fecha: {matchday}</span>
    </div>
  );
}

export default MatchdaySlider;
